import * as moment from "moment";
import "moment/locale/en-ca";
import "moment/locale/en-gb";
export const LocaleDate = () => {
    moment.locale("en-gb");
    let DateFormat = "DD/MM/YYYY";
    let DateTimeFormat = "DD/MM/YYYY HH:mm:ss";
    let TimeFormat = "HH:mm:ss";
    let Time24Hour = true;
    const offset = moment().utcOffset() / 60;
    if (offset <= -4 && offset >= -10) {
        moment.locale("en-ca");
        DateFormat = "MM/DD/YYYY";
        DateTimeFormat = "MM/DD/YYYY h:mm:ss A";
        TimeFormat = "h:mm:ss A";
        Time24Hour = false;
    }

    return ({
        DateFormat, DateTimeFormat, Time24Hour, TimeFormat,
    });
};

export const EUIFormatter = (value) => {
    const pattern = /^([0-9A-Fa-f]{2}[:]){7}([0-9A-Fa-f]{2})$/;
    const pattern1 = /^([0-9A-Fa-f]{4}[:]){3}([0-9A-Fa-f]{4})$/;
    if (value.match(pattern) || value.match(pattern1)) {
        // Remove ":" from the value
        const newValue = value.split(":").join("");
        // return value formatted with dashes
        return newValue.match(/.{1,2}/g).join("-");
    } else {
        return value;
    }
}

export const KeysFormatter = (value) => {
    const pattern = /^([0-9A-Fa-f]{2}[:-]){15}([0-9A-Fa-f]{2})$/;
    const pattern1 = /^([0-9A-Fa-f]{4}[:]){7}([0-9A-Fa-f]{4})$/;
    if (value.match(pattern) || value.match(pattern1)) {
        // Remove ":" or "-" from the value
        return value.replace(/[:|-]/g, "");
    } else {
        return value;
    }
}
